import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import {
    requestAddSourceProxy,
    requestRemovePassport,
    requestSourceProxyConfig,
    requestUpdateSourceProxy,
} from "./msgs/sourceProxyMsgSender";

import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import { SourceProxyID, SourceProxySettings } from "userful-chronos-app-common-js/dist/models/config/sourceProxy";

export interface InitialStateProxy {
    sourceProxyData: SourceProxySettings[];
    saveBool: boolean;
    overlay: boolean;
    selectedItems: StringID[];
}

const initialStateProxy: InitialStateProxy = {
    sourceProxyData: [],
    saveBool: false,
    overlay: false,
    selectedItems: [],
};

export const sourceProxySlice = createSlice({
    name: "sourceProxySlice",
    initialState: initialStateProxy,
    reducers: {
        getProxyDataFromServer: (state, action: PayloadAction<{}>) => {
            requestSourceProxyConfig();
        },
        setProxyData: (state, action: PayloadAction<SourceProxySettings[]>) => {
            state.sourceProxyData = action.payload;
        },
        addProxyDataToServer: (state, action: PayloadAction<SourceProxySettings>) => {
            state.saveBool = true;
            requestAddSourceProxy(action.payload);
        },
        updateProxyDataToServer: (state, action: PayloadAction<SourceProxySettings>) => {
            state.saveBool = true;
            requestUpdateSourceProxy(action.payload);
        },
        deleteProxyDataToServer: (state, action: PayloadAction<SourceProxyID>) => {
            state.saveBool = true;
            requestRemovePassport(action.payload);
        },
        setSaveBool: (state, action: PayloadAction<boolean>) => {
            state.saveBool = action.payload;
        },
        setOverlay: (state, action: PayloadAction<boolean>) => {
            state.overlay = action.payload;
        },
        addOrUpdateProxy: (state, action: PayloadAction<SourceProxySettings>) => {
            const foundIndex = state.sourceProxyData.findIndex((item) => item.id.value === action.payload.id.value);
            const foundSystemDefultIndex = state.sourceProxyData.findIndex((item) => item.systemProxy === true);
            const foundSourceDefultIndex = state.sourceProxyData.findIndex((item) => item.sourceDefault == true);

            if (
                action.payload.systemProxy &&
                foundSystemDefultIndex >= 0 &&
                state.sourceProxyData[foundSystemDefultIndex].id.value !== action.payload.id.value
            ) {
                const foundDefult = { ...state.sourceProxyData[foundSystemDefultIndex], systemProxy: false };

                state.sourceProxyData = [
                    ...state.sourceProxyData.slice(0, foundSystemDefultIndex),
                    { ...foundDefult },
                    ...state.sourceProxyData.slice(foundSystemDefultIndex + 1),
                ];
            }

            if (
                action.payload.sourceDefault &&
                foundSourceDefultIndex >= 0 &&
                state.sourceProxyData[foundSourceDefultIndex].id.value !== action.payload.id.value
            ) {
                const foundDefult = { ...state.sourceProxyData[foundSourceDefultIndex], sourceDefault: false };

                state.sourceProxyData = [
                    ...state.sourceProxyData.slice(0, foundSourceDefultIndex),
                    { ...foundDefult },
                    ...state.sourceProxyData.slice(foundSourceDefultIndex + 1),
                ];
            }

            if (foundIndex < 0) {
                state.sourceProxyData = [...state.sourceProxyData, { ...action.payload }];
            } else {
                state.sourceProxyData = [
                    ...state.sourceProxyData.slice(0, foundIndex),
                    { ...action.payload },
                    ...state.sourceProxyData.slice(foundIndex + 1),
                ];
            }
        },
        removeProxy: (state, action: PayloadAction<SourceProxyID>) => {
            state.sourceProxyData = state.sourceProxyData.filter((d) => d.id.value !== action.payload.value);
        },
        setSelectedItems: (state, action: PayloadAction<StringID[]>) => {
            state.selectedItems = action.payload;
        },
    },
});

export const sourceProxySliceActions = sourceProxySlice.actions;

export default sourceProxySlice.reducer;
